import { render, staticRenderFns } from "./tournamentRules.vue?vue&type=template&id=34a639fd&scoped=true&"
import script from "./tournamentRules.vue?vue&type=script&lang=js&"
export * from "./tournamentRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a639fd",
  null
  
)

export default component.exports